const getDeviationType = (deviationInSeconds: number): string => {
  const deviationInMinutes = Math.round(deviationInSeconds / 60);

  if (deviationInMinutes < 0) {
    return '!bg-deviation-early-subtle text-deviation-early-subtle-foreground';
  }

  if (deviationInMinutes < 3) {
    return '!bg-deviation-ontime-subtle text-deviation-ontime-subtle-foreground';
  }

  if (deviationInMinutes < 5) {
    return '!bg-deviation-delay-subtle text-deviation-delay-subtle-foreground';
  }

  return '!bg-deviation-too-late-subtle text-deviation-too-late-subtle-foreground';
};

export default getDeviationType;
